module.exports = __webpack_public_path__ + "media/assets/whatsapp-4468bc09b1f0203a94eb5583badec4db.svg";